/* 
-----------------------------------------------------------------------------
| DATE PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics.
*/
import { FC, useEffect } from "react";
import { DateSelection } from "../components/DateSelection";
import { ROUTES } from "../utils/symbols";

const params = new URLSearchParams(window.location.search)
const from = params.get('calendar')
const at = params.get('at') ?? from
const value = params.get('value') ?? undefined
const monthsQty = parseInt(params.get('months-qty') ?? '1', 10)
const specialDates = (params.get('special-dates') ?? '').split(',')

export const CalendarWidget: FC = () => {

    return (
        <main id="date-selection-page" className="page-container calendar-widget" role="application">
            <DateSelection 
                asCalendarWidget
                at={at}
                from={from}
                value={value}
                displayedMonthsQty={monthsQty}
                specialDates={specialDates}
            />
        </main>
    )
}